import type { ReactNode } from "react";
import { Sidebar } from "./Sidebar";

/**
 * Shell for authenticated routes: sidebar on the left, page content on the right.
 * Assumes the top bar and footer are rendered by the root app layout.
 */
export function AuthenticatedLayout({ children }: { children: ReactNode }) {
  return (
    <div className="app-body">
      <Sidebar />
      <div className="app-body-main">{children}</div>
    </div>
  );
}
